module.exports = __webpack_public_path__ + "static/media/email_reset_password.dc57c3f1.png";